'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultTextContainerController = function () {
  function DefaultTextContainerController($stateParams, adminService, loadingService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, DefaultTextContainerController);
    this.$stateParams = $stateParams;
    this.adminService = adminService;
    this.loadingService = loadingService;

    this.errMsg = '';
    this.defaultTexts = {};

    this.loadDefaultTexts();
  }

  (0, _createClass3.default)(DefaultTextContainerController, [{
    key: 'loadDefaultTexts',
    value: function loadDefaultTexts() {
      var _this = this;

      var ctrl = this;

      ctrl.loadingService.showLoading('defaultTexts', 'Loading Default Texts ...');

      ctrl.adminService.listDefaultTexts(ctrl.$stateParams.locationId).then(function (response) {
        _this.defaultTexts = response.data;
      }).finally(function () {
        ctrl.loadingService.hideLoading('defaultTexts');
      });
    }
  }, {
    key: 'saveChanges',
    value: function saveChanges() {
      var ctrl = this;

      ctrl.loadingService.showLoading('defaultTexts', 'Saving Changes ...');

      ctrl.adminService.updateDefaultTexts(ctrl.$stateParams.locationId, ctrl.defaultTexts).then(function (response) {}).finally(function () {
        ctrl.loadingService.hideLoading('defaultTexts');
      });
    }
  }]);
  return DefaultTextContainerController;
}();

exports.default = DefaultTextContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/defaultTextManagement/defaultTextContainer/defaultTextContainer.controller.js